import React from "react";
import { Row, Col, Timeline } from "antd";
import {
  dropoffTimelineIcon,
  homeIcon,
  pickupTimelineIcon,
} from "../../assets/images";
import styles from "../DashBoard/DashBoard.module.scss";
import { ITripDetails } from "../ServiceUsers/Interfaces/ITripDetails";

type Props = {
  trip: ITripDetails;
};

const AddressTimeline: React.FC<Props> = ({ trip }) => {
  return (
    <Row align="middle">
      <Col span={4} className={styles.distanceText}>
        <Row justify="end" align="middle">
          <Col>{trip?.providerDistance} mi</Col>
        </Row>
      </Col>
      <Col span={20} className={styles.customTimeline}>
        <Timeline>
          <Timeline.Item dot={<img src={pickupTimelineIcon} />}>
            <Row>
              <Col span={24} className={styles.addressHeading}>
                Pickup Address
              </Col>
              <Col span={24} className={styles.addressDetails1}>
                <img src={homeIcon} alt="pickup address" />
                <span>{trip?.pickUpAddress1}</span>
              </Col>
              <Col span={24} className={styles.addressDetails2}>
                {trip?.pickUpCity}, {trip?.pickUpState}{" "}
                {trip?.pickUpZipCode.toString().padStart(5, "0")}
              </Col>
            </Row>
          </Timeline.Item>
          <Timeline.Item dot={<img src={dropoffTimelineIcon} />}>
            <Row>
              <Col span={24} className={styles.addressHeading}>
                Dropoff Address
              </Col>
              <Col span={24} className={styles.addressDetails1}>
                {trip?.dropOffAddress1}
              </Col>
              <Col span={24} className={styles.addressDetails2}>
                {trip?.dropOffCity}, {trip?.dropOffState}{" "}
                {trip?.dropOffZipCode.toString().padStart(5, "0")}
              </Col>
            </Row>
          </Timeline.Item>
        </Timeline>
      </Col>
    </Row>
  );
};

export default AddressTimeline;
